import { PointTypes } from '@oneblink/types'

export type SubmissionPointAddress =
  | PointTypes.PointAddress
  | PointTypes.PointAddressV3GetAddressDetailsResponse

export function isPointAddressV3(
  address: SubmissionPointAddress,
): address is PointTypes.PointAddressV3GetAddressDetailsResponse {
  return (
    'properties' in address &&
    address.properties != null &&
    typeof address.properties === 'object' &&
    !(
      'addressDetails' in address &&
      address.addressDetails != null &&
      typeof address.addressDetails === 'object'
    )
  )
}

function getAddressDetailField(
  details: PointTypes.PointAddress['addressDetails'],
  field: string,
): string | undefined {
  if (!details) {
    return undefined
  }
  const value = details[field]
  return typeof value === 'string' ? value : undefined
}

export function getPointAddressLocalityName(
  address?: SubmissionPointAddress,
): string | undefined {
  if (!address) {
    return undefined
  }
  if (isPointAddressV3(address)) {
    return address.properties?.localityName
  }
  return address.addressDetails?.localityName
}

export function getPointAddressStateTerritory(
  address?: SubmissionPointAddress,
): string | undefined {
  if (!address) {
    return undefined
  }
  if (isPointAddressV3(address)) {
    return address.properties?.stateTerritory
  }
  return address.addressDetails?.stateTerritory
}

export function getPointAddressPostalDeliveryType(
  address?: SubmissionPointAddress,
): string | undefined {
  if (!address) {
    return undefined
  }
  if (isPointAddressV3(address)) {
    return address.properties?.postalDeliveryTypeCode
  }
  return getAddressDetailField(address.addressDetails, 'postalDeliveryType')
}
